import {BaseTileProvider} from './base-tile-provider';
import {MapType} from '../../enums/map-type';
import {sprintf} from 'sprintf-js';
import {MapProvider} from '../../enums/map-provider.enum';
import {SettingsService} from '../../services/settings.service';

export class BingMapsTileProvider extends BaseTileProvider {

  private static BING_MAPS_KEY = 'AscxXMFat6qzAFeM5977y6fPWauWhm5FLgKplCmsk4NoMboVQMOv0SB00xPwl4_x';
  private static URL_BING_MAPS = 'https://tiles.virtualearth.net/tiles/%s%s.png?g=2271&mkt=en-US&n=z&token=' + BingMapsTileProvider.BING_MAPS_KEY; // tiles/[a,r,h,o,b][num]

  getMapProvider(): string {
    return MapProvider.BING_MAPS;
  }

  getMaxZoom(): number {
    return 19;
  }

  getUrlTemplate(): string {
    return "";
  }

  getUrl(x, y, zoom, mapType?: MapType): string {
    let mt = mapType;
    if(!mt){
      mt = SettingsService.settings.mapType;
    }
    let url = '';
    switch (mt) {
      case MapType.MAP:
        url = sprintf(BingMapsTileProvider.URL_BING_MAPS, 'r', this.bingTileXYToQuadKey(x, y, zoom));
        break;
      case MapType.SATELLITE:
        url = sprintf(BingMapsTileProvider.URL_BING_MAPS, 'a', this.bingTileXYToQuadKey(x, y, zoom));
        break;
      case MapType.HYBRID:
        url = sprintf(BingMapsTileProvider.URL_BING_MAPS, 'h', this.bingTileXYToQuadKey(x, y, zoom));
        break;
      case MapType.TERRAIN:
        url = sprintf(BingMapsTileProvider.URL_BING_MAPS, 'a', this.bingTileXYToQuadKey(x, y, zoom));
        break;
    }
    return url;
  }

  bingTileXYToQuadKey(x, y, zoom): string {
    let quadKey = '';
    for (let i = zoom; i > 0; i--) {
      let digit = 0;
      const mask = 1 << (i - 1);
      if ((x & mask) !== 0) {
        digit++;
      }
      if ((y & mask) !== 0) {
        digit++;
        digit++;
      }
      quadKey += digit;
    }

    return quadKey;
  }
}
